import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import * as globals from "app/resources/globals";
import { Destino, GetDestinoFromState } from "./model";
import { DestinosList } from "./listmem";
import { syncViaje, IniciarEnDispositivo, cancelarViajeApp } from "../logic";
import { IniciarViajeEdit, IniciarViajeModel } from "./iniciar";
import { onSincronizar } from "./logic";

export interface Props {
    value: models.ViajeAppIniciado | null;
    onChange: (x: models.ViajeAppIniciado) => Promise<void>
}

const SyncButton = kea.defaultProps(kea.Button, { children: "Sincronizar datos", iconClass: fa("download"), style: "info" });
const IniciarButton = kea.defaultProps(kea.Button, { children: "Iniciar viaje", iconClass: fa("check"), style: "success" });
const CancelarButton = kea.defaultProps(kea.Button, { children: "Cancelar viaje", style: "danger", iconClass: fa("times") });

class ListaDestinosNoRx extends React.PureComponent<Props> {
    viaje = (props: Props) => props.value;
    items = createSelectorRx(this.viaje, viaje => viaje ? GetDestinoFromState(viaje) : []);
    modalManager = kea.createModalManager();
    syncDatos = async () => {
        await onSincronizar();
    }

    onIniciarViaje = async () => {
        const response = await this.modalManager.showModal(IniciarViajeEdit, undefined, {} as IniciarViajeModel);
        if (response.result) {
            const value = response.value;
            await IniciarEnDispositivo(value.idViajeEAD);
            await kea.message("Viaje iniciado", "", "success");
        }
    }

    onCancelarViaje = async () => {
        if (await kea.yesno("¿Cancelar el viaje?")) {
            //Antes de cancelar tratamos de sincronizar, esto por si hay datos en el cliente que impedirian la cancelación
            await syncViaje();
            const ret = await cancelarViajeApp();
            //TODO: Manejar mensajes de error
            await kea.message("Viaje cancelado");
        }
    }

    render() {
        const noHayDatos = 
        <div className="alert alert-warning">
            <label>Dispositivo sin datos</label>
            <br />
            No hay datos de un viaje de EAD almacenados en este dispositivo
            
            <br />
            <div className="btn-group">
                <IniciarButton onClick={this.onIniciarViaje} />
                <SyncButton onClick={this.syncDatos} />
            </div>
        </div>;


        return (
            <div>
                {
                (this.props.value != null) ?
                (
                    this.props.value.datos.ViajeTieneSalida ?
                        <DestinosList
                            items={this.items(this.props)}
                            idViajeEAD={this.props.value.idViajeEAD}
                            value={this.props.value}
                            onChange={this.props.onChange}
                        /> :
                        <div className="alert alert-warning">
                            <h3>Viaje iniciado, falta dar salida</h3>
                            <br />
                            Folio de viaje: {this.props.value.folioViajeEAD}            
                            <hr />
                            <br />
                            Indique al operador <b>dar salida</b> a su viaje y de click en <b>sincronizar</b>
                            <hr />
                            <div className="btn-group">
                                <SyncButton onClick={this.syncDatos} />
                                <CancelarButton onClick={this.onCancelarViaje} />
                            </div>
                        </div>
                
                ) :
                        noHayDatos
                }
                {this.modalManager.component}
            </div>
        )
    }
}

const ListaDestinosRx = componentToRx(ListaDestinosNoRx);

const destinos = globals.state.map(x => x.viajeApp);
export class ListaDestinos extends React.PureComponent {
    render() {
        return <ListaDestinosRx value={destinos} onChange={x => globals.setState({ viajeApp: x })} />;
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/list.tsx